import React, { useEffect, useRef, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth, functions, httpsCallable } from "../../firebase";
import { Row, Spinner } from "reactstrap";
import { consumeStoredGmailRedirectUri } from "utils/gmailSupportUtils";

export default function GmailCallback() {
  const location = useLocation();
  const history = useHistory();
  const exchanged = useRef(false);
  const [status, setStatus] = useState("loading");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const error = params.get("error");
    const state = params.get("state");

    if (error) {
      setErrorMsg(`Google declined authorization: ${error}`);
      setStatus("error");
      return undefined;
    }

    if (!code || !state) {
      setErrorMsg("Google did not return the information needed to complete the Gmail connection.");
      setStatus("error");
      return undefined;
    }

    const exchange = async () => {
      if (exchanged.current) return;
      exchanged.current = true;

      try {
        const exchangeFn = httpsCallable(functions, "gmailSupportExchangeToken");
        const redirectUri = consumeStoredGmailRedirectUri();
        await exchangeFn({ code, state, redirectUri });
        history.replace("/admin/ai-assistant");
      } catch (err) {
        console.error("[GmailCallback] gmailSupportExchangeToken error:", err);
        exchanged.current = false;
        setErrorMsg(err.message || "Failed to connect Gmail. Please try again.");
        setStatus("error");
      }
    };

    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      if (firebaseUser) {
        clearTimeout(authTimeout);
        unsubscribe();
        exchange();
      }
    });

    const authTimeout = setTimeout(() => {
      unsubscribe();
      setErrorMsg(
        "Could not restore your session. Log in as an admin, then reconnect Gmail from HAL.",
      );
      setStatus("error");
    }, 8000);

    return () => {
      clearTimeout(authTimeout);
      unsubscribe();
    };
  }, [history, location.search]);

  if (status === "loading") {
    return (
      <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", flexDirection: "column", gap: "16px" }}>
        <Spinner style={{ height: "3rem", width: "3rem" }} color="info" />
        <p style={{ color: "#004aad", fontWeight: "bold" }}>Connecting Gmail for HAL...</p>
      </Row>
    );
  }

  return (
    <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", flexDirection: "column", gap: "12px", padding: "20px" }}>
      <i className="fa fa-exclamation-circle" style={{ fontSize: "48px", color: "#e74c3c" }} />
      <h4 style={{ color: "#004aad", fontWeight: "bold" }}>Gmail Connection Failed</h4>
      <p style={{ color: "#666", textAlign: "center", maxWidth: "420px" }}>{errorMsg}</p>
      <button
        onClick={() => history.replace("/admin/ai-assistant")}
        style={{ marginTop: "8px", padding: "10px 24px", borderRadius: "30px", backgroundColor: "#004aad", color: "white", border: "none", cursor: "pointer", fontWeight: "bold" }}
      >
        Back to HAL
      </button>
    </Row>
  );
}
